import { KeyedLoaded } from "common/loader";
import { UpdateResult } from "../types";

export enum TypeKeys {
    LOADING = "STRIPE/UPDATE_BEGIN",
    SUCCESS = "STRIPE/UPDATE_SUCCESS",
    FAILURE = "STRIPE/UPDATE_FAILURE",
    RESET = "STRIPE/RESET",
}
export const createAction = {
    loading: () => ({ type: TypeKeys.LOADING }),
    loaded: (data: UpdateResult) => ({ type: TypeKeys.SUCCESS, data }),
    failed: (error: any) => ({ type: TypeKeys.FAILURE, error }),
    reset: () => ({ type: TypeKeys.RESET }),
};

type LoadingAction = { type: TypeKeys.LOADING; key: string };
type LoadedAction = { type: TypeKeys.SUCCESS; key: string; data: UpdateResult };
type FailedAction = { type: TypeKeys.FAILURE; key: string; error: any };
type ResetAction = { type: TypeKeys.RESET };

type UploadAction = LoadingAction | LoadedAction | FailedAction | ResetAction;

export type State = KeyedLoaded<UpdateResult, string | undefined>;

const initialState: State = {
    status: "unloaded",
};

export function reducer(state: State = initialState, action: UploadAction): State {
    if (action.type === TypeKeys.LOADING) {
        return {
            status: "loading",
            key: action.key,
        };
    }

    if (action.type === TypeKeys.SUCCESS) {
        const { data, key } = action;

        return {
            status: "loaded",
            key,
            data,
        };
    }

    if (action.type === TypeKeys.FAILURE) {
        const { error, key } = action;

        return {
            status: "failed",
            key,
            error,
        };
    }

    if (action.type === TypeKeys.RESET) {
        return initialState;
    }

    return state;
}
